import { FLOODGATE_API_ROOT, FloodgateSettingDataType } from './constants';
import { makePatchRequest } from 'owa-ows-gateway';
import prefetch from 'owa-service/lib/prefetch';

export default function upsertSettings(request: FloodgateSettingDataType) {
    prefetch(() => {
        makePatchRequest(
            FLOODGATE_API_ROOT,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            true /* isThrottled */
        );
    });
}
